//ReactDnd requires that you specify the type of item you are dragging.
const ITEM_TYPE = "ITEM";

export default ITEM_TYPE;
